import { promise } from '../../../helpers';
import { getBooks } from './index';

const validateOnSaveBook = item => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        const { id: bookId, name, categoryId, idSAP } = item;

        return dispatch(
            getBooks({
                where: [
                    ['categoryId', '==', categoryId],
                    ['name', '==', name],
                    ['idSAP', '==', idSAP],
                ],
            }),
        ).then(items => {
            if (items.length) {
                // "is unique" validation
                const isUnique =
                    items.filter(book => {
                        if (book.id === bookId) {
                            return false;
                        }

                        return true;
                    }).length === 0;

                if (!isUnique) {
                    return promise({
                        success: false,
                        errorMsg: 'El nombre del libro, idSAP y categoría ya se encuentran registrados.',
                    });
                }
            }

            return promise({ success: true });
        });
    };
};

export default validateOnSaveBook;
